import { useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { Button } from '../ui/button';

import CookieCategoriesGrid from './CookieCategoriesGrid';
import { useConsentForm } from './useConsentForm';

/** Bottom-of-page banner. Rendered only until a decision is recorded for the active policy. */
const CookieConsent = () => {
  const form = useConsentForm('banner');
  const [isCustomizeOpen, setIsCustomizeOpen] = useState(false);

  if (!form.isReady || form.hasCurrentConsent) return null;

  const handleAcceptAll = async () => {
    await form.acceptAll();
  };
  const handleRejectAll = async () => {
    await form.rejectAll();
  };
  const handleSaveCustom = async () => {
    if (await form.saveCustom()) setIsCustomizeOpen(false);
  };
  const handleToggleCustomize = () => setIsCustomizeOpen(o => !o);

  return (
    <div className="fixed inset-x-0 bottom-0 z-50" data-testid="panel-cookie-consent-banner">
      <div className="border-t border-[#e4ddd4] bg-white shadow-[0_-18px_40px_-32px_rgba(23,21,19,0.35)]">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-3 sm:px-6">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <p className="text-sm leading-5 text-[#4f473e]" data-testid="text-cookie-banner-description">
              <FormattedMessage id="CookieConsent.bannerDescription" />{' '}
              <a
                href="/privacy-policy#cookie-preferences"
                className="font-medium text-primary underline-offset-4 hover:underline"
                data-testid="link-cookie-privacy-policy"
              >
                <FormattedMessage id="CookieConsent.privacyPolicyLink" />
              </a>
              .
            </p>
            <div className="flex flex-wrap gap-2 lg:justify-end">
              <Button
                type="button"
                variant="ghost"
                className="h-9 px-3 text-xs font-heading uppercase tracking-[0.14em] text-[#5f584e]"
                onClick={handleToggleCustomize}
                data-testid="button-cookie-customize"
              >
                <FormattedMessage id={isCustomizeOpen ? 'CookieConsent.hideOptions' : 'CookieConsent.customize'} />
              </Button>
              <Button
                type="button"
                variant="outline"
                className="h-9 border-[#d9cebf] bg-white px-3 text-xs font-heading uppercase tracking-[0.14em]"
                onClick={handleRejectAll}
                disabled={form.isSubmitting}
                data-testid="button-cookie-reject-optional"
              >
                <FormattedMessage id="CookieConsent.rejectAll" />
              </Button>
              <Button
                type="button"
                className="h-9 px-3 text-xs font-heading uppercase tracking-[0.14em]"
                onClick={handleAcceptAll}
                disabled={form.isSubmitting}
                data-testid="button-cookie-accept-all"
              >
                <FormattedMessage id="CookieConsent.acceptAll" />
              </Button>
            </div>
          </div>

          {isCustomizeOpen && (
            <div className="space-y-3 border-t border-[#ede6dd] pt-4">
              <CookieCategoriesGrid draft={form.draft} onToggle={form.toggle} />
              <div className="flex justify-end">
                <Button
                  type="button"
                  variant="ghost"
                  className="h-9 px-3 text-xs font-heading uppercase tracking-[0.14em] text-[#5f584e]"
                  onClick={handleSaveCustom}
                  disabled={form.isSubmitting}
                  data-testid="button-cookie-save-preferences"
                >
                  <FormattedMessage id="CookieConsent.saveChoices" />
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
